module.exports = __webpack_public_path__ + "img/upsell-intro-phones-mobile.eee7cf5.png";